import { isNotDefined } from '@hsp/utilities';

import SecretKeyApproval from '@c/notifications/components/secret-key-approval/secret-key-approval.component';
import SecretKeyRequest from '@c/notifications/components/secret-key-request/secret-key-request.component';
import { NotificationTarget } from '@c/notifications/types';

import { useSignalREffect } from '@h/signalr';

import { notifications } from '@u/notifications';

export const useExternalListBroadcasts = () => {
  useSignalREffect(
    NotificationTarget.SecretKeyApprove,
    (notification) => {
      if (isNotDefined(notification)) {
        return;
      }

      const { id: toastId, isError, message } = notification;

      if (isError) {
        return;
      }

      const { payload } = notification;

      if (isNotDefined(payload) || isNotDefined(message)) {
        return;
      }

      notifications.info(
        <SecretKeyApproval
          {...payload}
          message={message}
        />,
        undefined,
        {
          toastId,
        }
      );
    },
    []
  );

  useSignalREffect(
    NotificationTarget.SecretKeyDeny,
    (notification) => {
      if (isNotDefined(notification)) {
        return;
      }

      const { id: toastId, isError, message } = notification;

      if (isError) {
        notifications.error(message, undefined, {
          toastId,
        });
      } else {
        notifications.warning(message, undefined, {
          toastId,
        });
      }
    },
    []
  );

  useSignalREffect(
    NotificationTarget.SecretKeyRequest,
    (notification) => {
      if (isNotDefined(notification)) {
        return;
      }

      const { id: toastId, isError, message } = notification;

      if (isError) {
        return;
      }

      const { payload } = notification;

      if (isNotDefined(toastId) || isNotDefined(payload) || isNotDefined(message)) {
        return;
      }

      notifications.info(
        <SecretKeyRequest
          {...{ ...payload, notificationId: toastId }}
          message={message}
        />,
        undefined,
        {
          toastId,
        }
      );
    },
    []
  );
};
